import "@arco-design/web-react/es/Dropdown/style";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import _IconNotification from "@arco-design/web-react/icon/react-icon/IconNotification";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import _IconLanguage from "@arco-design/web-react/icon/react-icon/IconLanguage";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import _IconExperiment from "@arco-design/web-react/icon/react-icon/IconExperiment";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import _IconTag from "@arco-design/web-react/icon/react-icon/IconTag";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import React, { useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import Logo from '@/assets/logo.svg';
import MessageBox from '@/components/MessageBox';
import IconButton from './IconButton';
import Settings from '../Settings';
import styles from './style/index.module.less';
import defaultLocale from '@/locale';
import useStorage from '@/utils/useStorage';
import { generatePermission } from '@/routes';

function Navbar({
  show
}) {
  const t = useLocale();
  const userInfo = useSelector(state => state.userInfo);
  const dispatch = useDispatch();
  const [_, setUserStatus] = useStorage('userStatus');
  const [role, setRole] = useStorage('userRole', 'admin');
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext);

  function logout() {
    localStorage.removeItem('token');
    setUserStatus('logout');
    window.location.href = '/login';
  }

  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout();
    } else {
      _Message.info(`You clicked ${key}`);
    }
  }

  useEffect(() => {
    dispatch({
      type: 'update-userInfo',
      payload: {
        userInfo: { ...userInfo,
          permissions: generatePermission(role)
        }
      }
    });
  }, [role]);

  if (!show) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['fixed-settings']
    }, /*#__PURE__*/React.createElement(Settings, {
      trigger: /*#__PURE__*/React.createElement(_Button, {
        icon: /*#__PURE__*/React.createElement(_IconSettings, null),
        type: "primary",
        size: "large"
      })
    }));
  }

  const handleChangeRole = () => {
    const newRole = role === 'admin' ? 'user' : 'admin';
    setRole(newRole);
  };

  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    onClickMenuItem: onMenuItemClick
  }, /*#__PURE__*/React.createElement(_Menu.SubMenu, {
    key: "role",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_IconUser, {
      className: styles['dropdown-icon']
    }), /*#__PURE__*/React.createElement("span", {
      className: styles['user-role']
    }, role === 'admin' ? t['menu.user.role.admin'] : t['menu.user.role.user']))
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    onClick: handleChangeRole,
    key: "switch role"
  }, /*#__PURE__*/React.createElement(_IconTag, {
    className: styles['dropdown-icon']
  }), t['menu.user.switchRoles'])), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "setting"
  }, /*#__PURE__*/React.createElement(_IconSettings, {
    className: styles['dropdown-icon']
  }), t['menu.user.setting']), /*#__PURE__*/React.createElement(_Menu.SubMenu, {
    key: "more",
    title: /*#__PURE__*/React.createElement("div", {
      style: {
        width: 80
      }
    }, /*#__PURE__*/React.createElement(_IconExperiment, {
      className: styles['dropdown-icon']
    }), t['message.seeMore'])
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "workplace"
  }, /*#__PURE__*/React.createElement(_IconDashboard, {
    className: styles['dropdown-icon']
  }), t['menu.dashboard.workplace'])), /*#__PURE__*/React.createElement(_Divider, {
    style: {
      margin: '4px 0'
    }
  }), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout"
  }, /*#__PURE__*/React.createElement(_IconPoweroff, {
    className: styles['dropdown-icon']
  }), t['navbar.logout']));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(Logo, null), /*#__PURE__*/React.createElement("div", {
    className: styles['logo-name']
  }, "Arco Pro"))), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Input.Search, {
    className: styles.round,
    placeholder: t['navbar.search.placeholder']
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Select, {
    triggerElement: /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(_IconLanguage, null)
    }),
    options: [{
      label: '中文',
      value: 'zh-CN'
    }, {
      label: 'English',
      value: 'en-US'
    }],
    value: lang,
    triggerProps: {
      autoAlignPopupWidth: false,
      autoAlignPopupMinWidth: true,
      position: 'br'
    },
    trigger: "hover",
    onChange: value => {
      setLang(value);
      const nextLang = defaultLocale[value];

      _Message.info(`${nextLang['message.lang.tips']}${value}`);
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MessageBox, null, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(_IconNotification, null)
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Tooltip, {
    content: theme === 'light' ? t['settings.navbar.theme.toDark'] : t['settings.navbar.theme.toLight']
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: theme !== 'dark' ? /*#__PURE__*/React.createElement(_IconMoonFill, null) : /*#__PURE__*/React.createElement(_IconSunFill, null),
    onClick: () => setTheme(theme === 'light' ? 'dark' : 'light')
  }))), /*#__PURE__*/React.createElement(Settings, null), userInfo && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Dropdown, {
    droplist: droplist,
    position: "br"
  }, /*#__PURE__*/React.createElement(_Avatar, {
    size: 32,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "avatar",
    src: userInfo.avatar
  }))))));
}

export default Navbar;